"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiselectDropdownClient = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MultiselectDropdown = _interopRequireDefault(require("../../MultiselectDropdown/MultiselectDropdown"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MultiselectDropdownClient = _ref => {
  let {
    id,
    label,
    items,
    values,
    setValues,
    activeItems,
    onKeyDown,
    ignoreSort
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [hasChanged, setHasChanged] = (0, _react.useState)(false);
  const [internalValues, setInternalValues] = (0, _react.useState)(values);
  const itemList = items?.map(item => {
    return {
      id: item.id,
      label: item.label,
      active: !!internalValues?.find(activeItem => activeItem == item.id),
      disabled: !activeItems.find(activeItem => activeItem?.id == item.id)
    };
  }) || [];
  return /*#__PURE__*/_react.default.createElement(_MultiselectDropdown.default, {
    id: id,
    label: label,
    items: itemList,
    onClickItem: (event, item, updatedItems) => {
      if (!isOpen) {
        setValues(updatedItems?.filter(item => item.active)?.map(item => item.id));
      } else setHasChanged(true);
      setInternalValues(updatedItems?.filter(item => item.active)?.map(item => item.id));
    },
    onKeyDown: onKeyDown,
    isOpen: isOpen,
    ignoreSort: ignoreSort,
    toggle: () => {
      setIsOpen(!isOpen);
      //setInternalActiveItems(activeItems);
      !isOpen && setHasChanged(false);
      hasChanged && isOpen && setValues(internalValues);
    }
  });
};
exports.MultiselectDropdownClient = MultiselectDropdownClient;